import SelectSearchField from 'components/Molecules/Form/SelectSearchField'
import CountrySelectSearch from 'components/Atoms/CountrySelectSearch'

const CountrySelectSearchField = props => (
  <SelectSearchField {...props} Component={CountrySelectSearch} />
)

export default CountrySelectSearchField
